import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { ViewerService } from '../services/viewer/ViewerService';
export function Canvas() {
    const broadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const setCanvas = useCallback((canvas) => {
        const viewerService = ViewerService.getNotificationInterface();
        if (canvas) {
            viewerService.notifyActivateBroadcast(broadcast, canvas);
        }
        else {
            viewerService.notifyDeactivateBroadcast();
        }
    }, [broadcast]);
    return _jsx("canvas", { ref: setCanvas });
}
